import {getToken} from '@/helpers/local-storage';
import _, {isEqual, assign} from 'lodash';
import i18n from '@/locales/i18n';

export const compareTwoObject = (object1: object = {}, object2: object = {}): boolean => {
	return isEqual(object1, object2);
};

export const isEmptyObject = (object: object): boolean => {
	return !object || (Object.keys(object).length === 0 && object.constructor === Object);
};

export const isObject = (obj: object): boolean => obj && typeof obj === 'object' && !Array.isArray(obj);

export const ensureArray = (data: unknown): Array<any> => (Array.isArray(data) ? data : []);

export const ensureObject = (obj: object, defaultValue: object): Object => (isObject(obj) ? obj : isObject(defaultValue) ? defaultValue : {});

export const parseBoolean = (val: unknown): boolean => !(!val || val === 'false' || val === 'null' || val === 'undefined' || val === '0');

export const validateEmail = (email: string): boolean => {
	const re = /\S+@\S+\.\S+/;
	return re.test(email);
};

export const DATE_FORMAT = 'MM/DD/YYYY';

export const TIME_FORMAT = 'hh:mm:ss A';

export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const sleep = (ms: number): Promise<unknown> => new Promise((resolve) => setTimeout(resolve, ms));

export const isPromise = (func: Promise<unknown>): boolean => func && typeof func.then === 'function';

export const getHeaders = (options: object = {}): object =>
	Object.assign(
		{},
		{
			Authorization: `Bearer ${getToken()}`,
			'Content-Type': 'application/json',
			'X-localization': i18n.language,
		},
		options,
	);

export const getAuthorizationHeader = (options: object = {}): string => `Bearer ${getToken()}`;

export const isBrowser = typeof window !== 'undefined';

export const scrollTo = (element: HTMLElement, rest: unknown): void => {
	// const isIE = detectIE()
	const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

	if (!supportsNativeSmoothScroll) {
		// const [x, y] = rest;
		// const offsetTop = x?.top || x || 0;
		// const offsetLeft = x?.left || y || 0;
		// element.scrollTop = offsetTop;
		// element.scrollLeft = offsetLeft;
	} else {
		element.scrollTo(rest);
	}
};

export const commafy = (num: any): string => {
	let str = num.toString().split('.');
	if (str[0].length >= 4) {
		str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
	}
	if (str[1] && str[1].length >= 5) {
		str[1] = str[1].replace(/(\d{3})/g, '$1 ');
	}
	return str.join('.');
};

export const flattenObjectsArray = (values: Array<any>): any => {
	return assign({}, ...values);
};

export const fakeDelay = (ms: number): Promise<any> => {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
};

const stringToColor = (string: string): string => {
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = '#';

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */

	return color;
}

export const stringAvatar = (name: string): object => {
	return {
		sx: {
			bgcolor: stringToColor(name),
		},
		children: name
			.replace(/\s+/, ' ')
			.split(' ')
			.slice(0, 2)
			.map(v => v && v[0].toUpperCase())
			.join(''),
	};
}

export const encryptStr = (param: string): string => {
	return btoa(param);
}

export const decryptStr = (param: string): string => {
	return atob(param);
}

export const padWithZeros = (num: number, size: number): string => {
	let numStr = num.toString();
	while (numStr.length < size) {
		numStr = "0" + numStr;
	}
	return numStr;
}